export const common = {
  nav: {
    home: 'DOMŮ',
    services: 'SLUŽBY',
    about: 'O NÁS',
    contact: 'KONTAKT',
    getInTouch: 'Kontaktujte nás'
  },
  hero: {
    label: 'TECHNOLOGICKÝ PARTNER',
    headline: 'Technologie a obchodní služby spolehlivě dodané',
    subheadline: 'IT služby, poradenství, zpracování dat, obchodní zprostředkování a marketingová řešení pro moderní společnosti.',
    primaryBtn: 'Požádat o konzultaci',
    secondaryBtn: 'Zobrazit služby'
  },
  strengths: {
    tech: {
      title: 'Technologické zaměření',
      desc: 'Pokročilá IT řešení a digitální služby'
    },
    eu: {
      title: 'Evropské obchodní prostředí',
      desc: 'Provoz v rámci evropských standardů'
    },
    reliable: {
      title: 'Spolehlivé dodání služeb',
      desc: 'Konzistentní a profesionální provedení'
    },
    fast: {
      title: 'Rychlá komunikace',
      desc: 'Rychlá odezva a jasný dialog'
    }
  },
  services: {
    title: 'Naše služby',
    subtitle: 'Komplexní technologická a obchodní řešení',
    it: {
      title: 'IT služby',
      desc: 'Softwarová řešení, zpracování dat, podpora hostingu a správa technické infrastruktury pro vaše obchodní potřeby.'
    },
    mediation: {
      title: 'Obchodní zprostředkování',
      desc: 'Podpora v obchodních partnerstvích, koordinace a usnadnění obchodních vztahů napříč trhy.'
    },
    consulting: {
      title: 'Poradenství a odborné posudky',
      desc: 'Profesionální analýza, hodnocení a odborná doporučení pro strategická obchodní rozhodnutí.'
    },
    technical: {
      title: 'Technické a grafické práce',
      desc: 'Technická dokumentace, diagramy, digitální materiály a tvorba vizuálního obsahu.'
    },
    marketing: {
      title: 'Reklama a marketing',
      desc: 'Marketingová podpora, vývoj strategie, digitální aktiva a propagační kampaně.'
    },
    automation: {
      title: 'Automatizace procesů',
      desc: 'Zefektivnění opakujících se pracovních postupů prostřednictvím inteligentní automatizace, snížení manuální práce a zvýšení provozní efektivity.'
    },
    learnMore: 'Zjistit více'
  },
  about: {
    label: 'O NEXNOVA',
    title: 'Spolehlivost prostřednictvím struktury',
    description: 'NEXNOVA SOLUTIONS podporuje podniky technologiemi a profesionálními službami. Zaměřujeme se na poskytování strukturovaných, spolehlivých řešení, která pomáhají společnostem efektivně fungovat v moderním digitálním prostředí. Náš přístup kombinuje technické odborné znalosti s jasnou komunikací a obchodně orientovaným myšlením.',
    principles: {
      reliability: {
        title: 'Spolehlivost',
        desc: 'Konzistentní dodání a spolehlivá služba'
      },
      communication: {
        title: 'Jasná komunikace',
        desc: 'Transparentní a přímý dialog'
      },
      execution: {
        title: 'Strukturované provedení',
        desc: 'Organizovaný a metodický přístup'
      },
      business: {
        title: 'Obchodně orientovaná řešení',
        desc: 'Praktické a výsledkově zaměřené služby'
      }
    }
  },
  contact: {
    title: 'Kontaktujte nás',
    subtitle: 'Pojďme diskutovat o vašich technologických potřebách',
    address: 'Adresa',
    phone: 'Telefon',
    email: 'E-mail',
    form: {
      fullName: 'Celé jméno',
      emailLabel: 'E-mail',
      company: 'Společnost',
      phoneLabel: 'Telefon',
      message: 'Zpráva',
      privacy: 'Souhlasím se zpracováním mých osobních údajů',
      submit: 'Odeslat zprávu',
      success: 'Zpráva byla úspěšně odeslána!',
      error: 'Odeslání zprávy se nezdařilo. Zkuste to prosím znovu.',
      required: 'Toto pole je povinné',
      invalidEmail: 'Zadejte prosím platnou e-mailovou adresu',
      maxLength: 'Zpráva nesmí přesáhnout 500 znaků'
    }
  },
  footer: {
    tagline: 'Technologické a obchodní služby',
    description: 'NEXNOVA SOLUTIONS poskytuje komplexní IT služby, poradenství a obchodní podporu, aby pomohla společnostem prosperovat v digitálním věku.',
    navigation: 'Navigace',
    contactInfo: 'Kontakt',
    servicesTitle: 'Služby',
    copyright: '© 2026 NEXNOVA SOLUTIONS S.R.O. Všechna práva vyhrazena.'
  },
  servicePages: {
    cta: {
      title: 'Připraveni začít?',
      subtitle: 'Kontaktujte nás ještě dnes a proberme, jak vám můžeme pomoci s řešeními na míru a odbornou podporou.',
      btn: 'Požádat o konzultaci',
      back: 'Zpět na hlavní stránku',
    },
    it: {
      label: 'IT SLUŽBY',
      title: 'IT Služby',
      subtitle: 'Komplexní softwarová řešení, zpracování dat, hostingová infrastruktura a technická podpora — navržené tak, aby váš podnik fungoval naplno.',
      features: {
        f1: { title: 'Vývoj softwaru na míru', desc: 'Aplikace a platformy přizpůsobené vašim konkrétním obchodním procesům a cílům.' },
        f2: { title: 'Zpracování a správa dat', desc: 'Strukturované zpracování, transformace a ukládání obchodních dat s přesností a spolehlivostí.' },
        f3: { title: 'Hosting a cloudová infrastruktura', desc: 'Stabilní, škálovatelná hostingová prostředí s monitoringem, zálohami a optimalizací výkonu.' },
        f4: { title: 'Kybernetická bezpečnost a ochrana dat', desc: 'Bezpečnostní audity, řízení přístupu a opatření na ochranu dat v souladu s evropskými standardy.' },
        f5: { title: 'Systémová integrace', desc: 'Propojení vašich stávajících nástrojů, API a platforem do jednotného a efektivního pracovního toku.' },
        f6: { title: 'Technická podpora a údržba', desc: 'Průběžná podpora, aktualizace a řešení problémů pro stabilní a aktuální systémy.' },
      },
      details: {
        d1: {
          label: 'SOFTWAROVÁ ŘEŠENÍ',
          title: 'Software na míru pro skutečné obchodní potřeby',
          body: 'Vyvíjíme software přesně podle vašich požadavků — od interních nástrojů pro správu a klientských portálů až po datové pipeline a automatizační systémy. Každé řešení je navrženo s ohledem na škálovatelnost a udržitelnost, aby rostlo spolu s vaším podnikem.',
        },
        d2: {
          label: 'INFRASTRUKTURA A HOSTING',
          title: 'Spolehlivá infrastruktura, na kterou se můžete spolehnout',
          body: 'Naše hostingové a infrastrukturní služby poskytují pevný základ pro vaše digitální operace. Spravujeme serverová prostředí, cloudová nasazení a zálohovací strategie, aby se váš tým mohl soustředit na podnikání — ne na výpadky. Všechna prostředí jsou monitorována 24/7 s rychlou reakcí na incidenty.',
        },
      },
    },
    mediation: {
      label: 'OBCHODNÍ ZPROSTŘEDKOVÁNÍ',
      title: 'Obchodní zprostředkování',
      subtitle: 'Usnadňování obchodních partnerství, koordinace napříč trhy a správa obchodních vztahů s profesionalitou a jasností.',
      features: {
        f1: { title: 'Zprostředkování partnerství', desc: 'Identifikace a propojení kompatibilních obchodních partnerů napříč odvětvími a trhy.' },
        f2: { title: 'Přeshraniční koordinace', desc: 'Řízení komunikace a logistiky mezi stranami působícími v různých zemích nebo právních prostředích.' },
        f3: { title: 'Správa zainteresovaných stran', desc: 'Koordinace zájmů více stran k dosažení vzájemně výhodných výsledků.' },
        f4: { title: 'Podpora smluv a dohod', desc: 'Asistence při přípravě a kontrole obchodních smluv a partnerské dokumentace.' },
        f5: { title: 'Podpora při vyjednávání', desc: 'Profesionální vedení a zastoupení při obchodních jednáních na ochranu vašich zájmů.' },
        f6: { title: 'Řešení sporů', desc: 'Neutrální mediační služby pro rychlé řešení obchodních sporů bez soudního řízení.' },
      },
      details: {
        d1: {
          label: 'BUDOVÁNÍ PARTNERSTVÍ',
          title: 'Budujeme mosty mezi podniky',
          body: 'NEXNOVA SOLUTIONS působí jako důvěryhodný zprostředkovatel, který pomáhá společnostem navazovat a udržovat produktivní obchodní vztahy. Ať už vstupujete na nový trh, hledáte spolehlivého dodavatele nebo distribučního partnera, zajišťujeme koordinaci a komunikaci, aby vše proběhlo hladce.',
        },
        d2: {
          label: 'PŘESHRANIČNÍ DOSAH',
          title: 'Rozšiřte svůj dosah na nové trhy',
          body: 'Působíme na evropských trzích a pomáháme podnikům orientovat se ve složitostech přeshraničního obchodu. Od jazykových a kulturních rozdílů po regulatorní požadavky — naše mediační služby zajišťují, že vaše obchodní vztahy jsou postaveny na pevném a transparentním základě, bez ohledu na geografii.',
        },
      },
    },
    consulting: {
      label: 'PORADENSTVÍ A ODBORNÉ POSUDKY',
      title: 'Poradenství a odborné posudky',
      subtitle: 'Strategická analýza, profesionální hodnocení a odborná doporučení pro vaše nejdůležitější obchodní rozhodnutí.',
      features: {
        f1: { title: 'Strategické obchodní poradenství', desc: 'Hloubková analýza vašeho obchodního modelu, tržní pozice a příležitostí k růstu.' },
        f2: { title: 'Analýza trhu a konkurence', desc: 'Výzkum tržních trendů, pozicování konkurentů a dynamiky odvětví podložený daty.' },
        f3: { title: 'Due diligence a audity', desc: 'Důkladné hodnocení obchodních procesů, financí a provozních rizik před klíčovými rozhodnutími.' },
        f4: { title: 'Odborné zprávy a posudky', desc: 'Formální písemné odborné posudky a hodnocení pro právní, obchodní nebo regulatorní účely.' },
        f5: { title: 'Optimalizace procesů', desc: 'Identifikace neefektivit a doporučení strukturovaných zlepšení vašich operací.' },
        f6: { title: 'Regulatorní a compliance poradenství', desc: 'Orientace v evropských předpisech, požadavcích na shodu a oborových standardech.' },
      },
      details: {
        d1: {
          label: 'STRATEGICKÉ PORADENSTVÍ',
          title: 'Odborné vedení pro chytřejší rozhodnutí',
          body: 'Naše poradenská praxe kombinuje hluboké znalosti odvětví s analytickou přísností. Úzce spolupracujeme s vaším vedením, abychom pochopili vaše výzvy, zhodnotili možnosti a poskytli jasná, realizovatelná doporučení. Ať plánujete expanzi, restrukturalizaci nebo vstup na nový trh, poskytneme vám strategickou jasnost.',
        },
        d2: {
          label: 'ODBORNÉ POSUDKY',
          title: 'Formální hodnocení, na která se můžete spolehnout',
          body: 'Zpracováváme profesionální odborné posudky a hodnotící zprávy pro širokou škálu účelů — od podpory soudních řízení a regulatorních podání až po informování investičních rozhodnutí. Naše hodnocení jsou důkladná, dobře zdokumentovaná a dodána s přesností, kterou náročné situace vyžadují.',
        },
      },
    },
    technical: {
      label: 'TECHNICKÉ A GRAFICKÉ PRÁCE',
      title: 'Technické a grafické práce',
      subtitle: 'Přesná technická dokumentace, profesionální diagramy a kvalitní vizuální obsah — vytvořené tak, aby vaše myšlenky byly srozumitelné a efektivně komunikovány.',
      features: {
        f1: { title: 'Technická dokumentace', desc: 'Strukturované a přesné technické dokumenty, manuály a specifikace přizpůsobené standardům vašeho odvětví.' },
        f2: { title: 'Technické výkresy a schémata', desc: 'Detailní technické výkresy, vývojové diagramy a schémata pro strojírenství, stavebnictví a procesní dokumentaci.' },
        f3: { title: 'Digitální grafický design', desc: 'Profesionální vizuální materiály včetně ilustrací, infografik a brandovaných digitálních podkladů.' },
        f4: { title: 'Sazba a tiskový design', desc: 'Čisté, strukturované layouty pro zprávy, prezentace, brožury a tiskové materiály.' },
        f5: { title: 'Příprava pro tisk', desc: 'Příprava souborů pro profesionální tisk se správnými barevnými profily, spadavkami a rozlišením.' },
        f6: { title: 'Vizuální identita značky', desc: 'Konzistentní vizuální jazyk napříč všemi materiály — loga, barevné systémy, typografie a grafické manuály.' },
      },
      details: {
        d1: {
          label: 'TECHNICKÁ DOKUMENTACE',
          title: 'Přesná dokumentace pro složité procesy',
          body: 'Vytváříme přehlednou, strukturovanou technickou dokumentaci splňující profesionální a regulatorní standardy. Od uživatelských manuálů a instalačních příruček po procesní schémata a technické výkresy — naše dokumentace je přesná, dobře organizovaná a snadno srozumitelná, čímž snižuje chybovost a zlepšuje provozní přehlednost.',
        },
        d2: {
          label: 'GRAFICKÝ A VIZUÁLNÍ DESIGN',
          title: 'Vizuální obsah, který komunikuje s dopadem',
          body: 'Naše grafické služby zahrnují vše od vizuální identity a digitálních ilustrací po tiskové layouty a propagační materiály. Kombinujeme technickou přesnost s kreativním myšlením, abychom vytvářeli vizuály, které jsou nejen krásné, ale i účelné — zajišťující konzistentní a profesionální komunikaci vaší značky na každém místě.',
        },
      },
    },
    marketing: {
      label: 'REKLAMA A MARKETING',
      title: 'Reklama a marketing',
      subtitle: 'Strategická marketingová podpora, digitální kampaně a propagační obsah navržené k posílení viditelnosti vaší značky a dosažení měřitelných obchodních výsledků.',
      features: {
        f1: { title: 'Vývoj marketingové strategie', desc: 'Tvorba marketingových plánů podložených daty, sladěných s vašimi obchodními cíli, cílovou skupinou a konkurenčním prostředím.' },
        f2: { title: 'Digitální reklamní kampaně', desc: 'Plánování a realizace online reklamy ve vyhledávačích, na display sítích a sociálních médiích.' },
        f3: { title: 'E-mail marketing', desc: 'Cílené e-mailové kampaně s přesvědčivým obsahem, segmentací a sledováním výkonu.' },
        f4: { title: 'Marketing na sociálních sítích', desc: 'Obsahová strategie, plánování příspěvků a správa komunity na klíčových sociálních platformách.' },
        f5: { title: 'Video a multimediální obsah', desc: 'Produkce propagačních videí, animací a multimediálních podkladů pro digitální i televizní využití.' },
        f6: { title: 'Analytika a reportování výkonu', desc: 'Sledování výsledků kampaní, měření ROI a poskytování praktických poznatků pro neustálé zlepšování výkonu.' },
      },
      details: {
        d1: {
          label: 'MARKETINGOVÁ STRATEGIE',
          title: 'Marketing postavený na strategii, který přináší výsledky',
          body: 'Efektivní marketing začíná jasnou strategií. Spolupracujeme s vámi na definování cílové skupiny, výběru správných kanálů a vytvoření uceleného plánu, který propojí vaši značku se správnými lidmi ve správný čas. Každá kampaň je podložena daty, sladěna s vašimi obchodními cíli a navržena tak, aby přinášela měřitelné výsledky.',
        },
        d2: {
          label: 'OBSAH A KAMPANĚ',
          title: 'Přesvědčivý obsah na každém kanálu',
          body: 'Od digitálních reklam a příspěvků na sociálních sítích po e-mailové sekvence a propagační videa — vytváříme obsah, který upoutá pozornost a motivuje k akci. Náš tým zajišťuje celý produkční cyklus — od konceptu a copywritingu po design a distribuci — aby vaše marketingové materiály byly konzistentní, profesionální a účinné na všech platformách.',
        },
      },
    },
    automation: {
      label: 'AUTOMATIZACE PROCESŮ',
      title: 'Automatizace procesů',
      subtitle: 'Inteligentní automatizační řešení, která eliminují opakující se úkoly, snižují manuální práci a uvolňují váš tým pro práci, která skutečně přináší hodnotu.',
      features: {
        f1: { title: 'Automatizace pracovních postupů', desc: 'Automatizace vícekrokových obchodních procesů pro odstranění úzkých míst a snížení manuálních zásahů.' },
        f2: { title: 'Mapování a návrh procesů', desc: 'Analýza a redesign vašich pracovních postupů k identifikaci příležitostí pro automatizaci a optimalizaci efektivity.' },
        f3: { title: 'Plánované a spouštěné úlohy', desc: 'Nastavení automatizovaných úloh spouštěných podle plánu nebo v reakci na konkrétní události a podmínky.' },
        f4: { title: 'RPA a inteligentní automatizace', desc: 'Robotická procesní automatizace pro opakující se zadávání dat, zpracování dokumentů a systémové interakce.' },
        f5: { title: 'Upozornění a notifikace', desc: 'Automatizovaný monitoring s chytrými upozorněními, která informují váš tým bez nutnosti manuální kontroly.' },
        f6: { title: 'Dashboardy automatizace', desc: 'Přehled v reálném čase o automatizovaných procesech s metrikami výkonu a sledováním stavu.' },
      },
      details: {
        d1: {
          label: 'AUTOMATIZACE PRACOVNÍCH POSTUPŮ',
          title: 'Eliminujte opakování. Zrychlte operace.',
          body: 'Analyzujeme vaše stávající pracovní postupy a identifikujeme místa, kde může automatizace přinést největší přínos. Nahrazením manuálních, opakujících se úkolů inteligentními automatizovanými procesy pomáháme vašemu týmu pracovat rychleji, dělat méně chyb a soustředit se na hodnotnější činnosti. Naše automatizační řešení jsou navržena tak, aby se bezproblémově integrovala s vašimi stávajícími nástroji.',
        },
        d2: {
          label: 'MONITORING A KONTROLA',
          title: 'Plný přehled nad vašimi automatizovanými procesy',
          body: 'Automatizace bez dohledu je riziko. Do každého řešení zabudováváme monitorovací vrstvu — poskytujeme dashboardy v reálném čase, automatická upozornění a podrobné logy, abyste vždy věděli, co běží, co bylo dokončeno a co vyžaduje pozornost. Naše systémy jsou navrženy pro spolehlivost s vestavěným zpracováním chyb a mechanismy obnovy.',
        },
      },
    },
  },
};